import Route from '@ember/routing/route';
import type StoreService from 'scaleflow/services/store';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';

class DepartmentsRoute extends Route {
  @service declare store: StoreService;

  beforeModel() {
    return Promise.all([
      this.store.findAll('goal'),
      this.store.findAll('initiative'),
      this.store.findAll('metric'),
    ]);
  }

  model() {
    return this.store.findAll('department');
  }
}

export default instrumentRoutePerformance(DepartmentsRoute);
